import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'wen-icon-arrow-right',
  templateUrl: './arrow-right.component.html',
  styleUrls: ['./arrow-right.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ArrowRightIconComponent {}
